
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'WhatsNewCard',
  props: {
    buttonText: {
      type: String,
      default: 'Migrate to Team plan'
    },
    learnMoreUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isExpanded: true
    }
  },
  methods: {
    toggleExpanded() {
      this.isExpanded = !this.isExpanded
    },
    handleCtaClick() {
      this.$emit('cta-click')
    }
  }
})
